import { graphql } from '@/generated/gql';

export const INTAKE_QUOTE_COMPLIANCE_QUERY = graphql(`
  query IntakeQuoteComplianceQuery($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        quote {
          id
        }
        analysis {
          id
          fileId
        }
        quoteCompliance {
          id
          chatSessionId
          quoteId
          score
          userComment
          userReason
          complianceData {
            summary
            parts {
              details
              section
              status
              sourceFileName
            }
          }
        }
      }
    }
  }
`);
